var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3333 10C18.3333 14.6 14.6 18.3333 10 18.3333C5.4 18.3333 2.59167 13.7 2.59167 13.7M2.59167 17.8667V13.7H6.35833M1.66667 10C1.66667 5.4 5.36667 1.66667 10 1.66667C15.5583 1.66667 18.3333 6.3 18.3333 6.3M14.6333 6.3H18.3333V2.13333",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvert);
export default __webpack_public_path__ + "static/media/convert.c4dd4570c2bcbbc67717523af0b8a28c.svg";
export { ForwardRef as ReactComponent };